import { b2x } from '@b2x/react/src';

export type CartSkuProps = b2x.CartSkuProps;

export const CartSku = (props: CartSkuProps) => <b2x.CartSku {...props} hideSkuName />;
